import {createI18n} from 'vue-i18n'
import isUndefined from 'lodash/isUndefined';
import merge from 'lodash/merge'


async function loadLocaleMessages(options) {
  const messages = {}
  let result = {}

  
    if(isUndefined(messages['en-gb'])) {
      messages['en-gb'] = {}
    }
    
      
        result = await import('~/core/locales/en-gb/index.ts')
    messages['en-gb'] = merge({}, messages['en-gb'], result)
    
    
      
        result = await import('~/../checkout-app/lib/locales/en-gb/index.mjs')
    messages['en-gb'] = merge({}, messages['en-gb'], result)
    
    
      
  
    if(isUndefined(messages['ru-ru'])) {
      messages['ru-ru'] = {}
    }
    
      
        result = await import('~/../checkout-app/lib/locales/en-gb/index.mjs')
    messages['ru-ru'] = merge({}, messages['ru-ru'], result)
    
    
      
  

  return messages
}


export default async (ctx, inject) => {
  const messages = await loadLocaleMessages()

  const i18n =  createI18n({
    locale: ctx.$store.getters['common/language/locale'],
    messages
  })
  ctx.app.use(i18n)

  return i18n
}